import { inject, Injectable } from '@angular/core'
import { FeathersService } from '../../feathers.service'
import { Worker } from '../../../models/worker'
import { firstValueFrom } from 'rxjs'
import { SrWorker } from '../../../models/sr-worker'
import { Assistant } from '../../../models/assistant'

@Injectable({
  providedIn: 'root',
})
export class WorkerService {

  protected readonly feathers = inject(FeathersService)

  async getAssistantByWorkerId(workerId: number): Promise<Assistant> {
    const assistants = await firstValueFrom(this.feathers.find(Assistant, { workerId }))
    if (assistants?.length) {
      return assistants[0]
    }
  }

  async getSrWorkerByWorkerId(workerId: number): Promise<SrWorker> {
    const srWorkers = await firstValueFrom(this.feathers.find(SrWorker, { workerId }))
    if (srWorkers?.length) {
      return srWorkers[0]
    }
  }

  async getSrWorkerByUserId(userId: number): Promise<SrWorker> {
    const workers = await firstValueFrom(this.feathers.find(Worker, { userId }))
    if (workers?.length === 1) {
      return await this.getSrWorkerByWorkerId(workers[0].id)
    }
  }

  static getPrimaryWorkerAllocation<T>(worker?: { workerAllocations?: T[] } | null): T | undefined {
    return worker?.workerAllocations?.[0]
  }

}